<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row row-spacing">
        <div class="col-md-6">
          <WidgetEscalations />
        </div>
        <div class="col-md-6" v-if="userContainsPermission(['CLIENT','CLIENT_ADMIN', 'SERVICES'])">
          <WidgetSegments />
        </div>
        <div :class="clients.length > 0 ? 'col-md-4' : 'col-md-6'">
          <WidgetTickets />
        </div>
        <div class="col-md-6" v-if="userContainsPermission(['CLIENT_ADMIN', 'BILLING'])">
          <WidgetDocuments />
        </div>
        <div class="col-md-6" v-if="userContainsPermission(['CLIENT_ADMIN', 'WORK_ORDERS'])">
          <WidgetWorkorders />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClientFunctions from "@/pages/ClientFunctions";
import WidgetSegments from "@/components/Dashboard/WidgetSegments";
import WidgetTickets from "@/components/Dashboard/WidgetTickets";
import WidgetWorkorders from "@/components/Dashboard/WidgetWorkorders";
import WidgetDocuments from "@/components/Dashboard/WidgetDocuments";
import WidgetEscalations from "@/components/Dashboard/WidgetEscalations";

export default {
  extends: ClientFunctions,
  components: {
    WidgetSegments,
    WidgetTickets,
    WidgetWorkorders,
    WidgetDocuments,
    WidgetEscalations,
  },
  data() {
    return {
      selectedClient: {},
      dashboardLayout: {},
      clients: [],
      userDetails: {},
    };
  },
  mounted() {
    const clientNumber = this.$route.params.clientNumber;
     this.$http.get(this.$config.aimsAPI + "users/user/loggedInUser").then(
      (response) => {
        this.userDetails = response.data;        

        this.$http.get(this.$config.aimsAPI + "dashboards/getclient/" + clientNumber).then(
          (response) => {
            this.selectedClient = response.data;
            if (this.selectedClient.type == "Corporate") {
              this.$root.$emit("SET_CLIENT_PAGE_TITLE", `${this.selectedClient.companyname} [${this.selectedClient.clientNumber}]`); 
            } else {
              this.$root.$emit("SET_CLIENT_PAGE_TITLE", `${this.userDetails.firstNames} ${this.userDetails.lastName} [${this.selectedClient.clientNumber}]`); 
            }
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching Client for Dashboard", error);
          }
        );  
      },
      (error) => {
        console.error(error);
        this.showError("Error Fetching User", error);
      }
    );

    this.$http.get(this.$config.aimsAPI + "dashboards/reseller/clients/" + clientNumber)
      .then(
        (response) => {
          this.clients = response.data;
        },
        (error) => {
          this.showError("Error fetching Reseller Clients ", error);
          console.error(error);
        }
      );
  },
  methods: {
    getWidgetIcon(widget) {
      return `fa fa-${widget.icon} fa-2x`;
    },
    getWidgetColour(widget) {
      switch (widget.colour) {
        case "green":
          return "bg-green";
        case "blue":
          return "bg-info";
        case "orange":
          return "bg-warning";
        case "gold":
          return "bg-gold";
        case "grey":
          return "bg-primary";
        case "dark-blue":
          return "bg-primary-dark";
        default:
          break;
      }
    }
  },
};
</script>

<style scoped>
.hover:hover {
  background: rgba(0, 0, 0, 0.15);
  color: red !important;
}
</style>